import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import RotatePDFImagesListScreen from "./RotatePDFImagesListScreen";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function RotatePDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Rotate PDF Pages For Free" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/rotate_pdf", title: "Flip PDF Pages Online Free" },
    data2: { link: "/rotate_pdf", title: "Rotate PDF Pages Online Free" },
    data3: { link: "/rotate_pdf", title: "Flip & Rotate PDF Pages" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Rotate PDF pages online easily. Turn, flip, or fix PDF page orientation quickly with our fast, secure, and simple PDF rotate tool."
      ></meta>
      <meta
        name="keywords"
        content="rotate pdf, rotate pdf online, rotate pdf pages, pdf page rotation, flip pdf pages, fix pdf orientation, pdf rotate tool, rotate pdf file, change pdf orientation, pdf editor online, pdf management tool, rotate scanned pdf, pdf page editor, rotate pdf free, rotate document pdf, rotate pdf page images, flip pdf pages, pdf page flipper, pdf flipper, flip pdf documents, mirror pdf, mirror pdf pages,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <RotatePDFImagesListScreen title={title}></RotatePDFImagesListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Rotate PDF Pages website provides a fast, secure, and easy-to-use solution to rotate and flip PDF documents both offline and online. Designed for students, professionals, and businesses, this powerful tool allows users to rotate PDF, rotate PDF pages, and flip PDF pages with precision while maintaining the original document quality. With offline functionality, all processing happens directly on your device, ensuring complete privacy and data security without uploading files to external servers. When internet access is available, users can easily rotate PDF pages online for free using a smooth, browser-based interface for instant results. Whether you need to correct scanned documents, adjust page orientation, or flip PDF pages horizontally or vertically, this tool delivers accurate and professional output. The platform also supports flip PDF pages free, making it accessible for everyday document needs without complicated setup or subscriptions. Using advanced page rotation technology, the tool preserves text clarity, images, and formatting during rotation and flipping. Compatible with desktop and mobile devices, this website helps users fix page orientation issues, improve document readability, and prepare PDFs for printing, sharing, or submission. If you are searching for a reliable solution to rotate PDF, flip PDF, rotate PDF pages, flip PDF pages, rotate PDF pages online for free, or flip PDF pages free both offline and online, this platform offers a complete, user-friendly PDF management experience." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Rotate",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Rotate PDF Pages Tool"
            why_use={[
              {
                title: "Fix Incorrect PDF Page Orientation",
                description:
                  "Scanned or imported documents often appear sideways or upside down. A rotate PDF pages tool helps correct orientation and makes PDFs easy to read.",
              },
              {
                title: "Improve Document Readability",
                description:
                  "Properly oriented pages enhance clarity and viewing experience. Using rotate PDF or flip PDF features ensures text and images display correctly.",
              },
              {
                title: "Prepare PDFs for Printing",
                description:
                  "Incorrect orientation can cause printing issues. With rotate PDF pages online for free, you can adjust pages before printing to avoid errors.",
              },
              {
                title: "Flip PDF Pages Horizontally or Vertically",
                description:
                  "Some documents require mirrored layouts. A flip PDF pages free tool allows horizontal or vertical flipping without affecting document quality.",
              },
              {
                title: "Save Time on Document Editing",
                description:
                  "Instead of rescanning or recreating files, a rotate PDF pages tool fixes orientation problems instantly.",
              },
              {
                title: "Preserve Original Quality",
                description:
                  "Advanced rotate PDF and flip PDF tools maintain text clarity and image resolution, keeping documents professional.",
              },
              {
                title: "Ideal for Scanned and Merged PDFs",
                description:
                  "Scanned and merged PDFs often contain mixed orientations. Rotate PDF pages tools quickly correct these inconsistencies.",
              },
              {
                title: "Work Offline for Better Privacy",
                description:
                  "An offline rotate PDF pages tool processes files locally, ensuring data privacy without uploading documents online.",
              },
              {
                title: "Rotate PDF Pages Online Anytime",
                description:
                  "With rotate PDF pages online for free, users can adjust PDF orientation from any device without installing software.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "What is a PDF rotator?",
                description:
                  "A PDF rotator is a tool that changes the orientation of PDF pages. It lets you rotate pages clockwise or counterclockwise to correct sideways or upside-down documents and make them easier to read or print.",
              },
              {
                title: "How can I rotate a PDF for free?",
                description:
                  "Open the PDF rotation tool on ShivaPDF.com, select your PDF file, choose the pages and rotation angle, and apply the changes. Download the rotated PDF when processing is complete.",
              },
              {
                title: "Can I rotate a PDF offline?",
                description:
                  "Yes, if the PDF rotator supports local processing, you can rotate PDF pages without an internet connection after the tool and its required resources have loaded. Offline availability depends on the implementation.",
              },
              {
                title: "Does ShivaPDF upload my PDF when rotating it?",
                description:
                  "A locally processed PDF rotator can change page orientation directly in your browser without sending the document to a server. Check the tool's implementation and privacy policy to confirm how your files are handled.",
              },
              {
                title: "How do I rotate a PDF page by 90 degrees?",
                description:
                  "Select your PDF in the rotation tool and choose a 90-degree clockwise or counterclockwise rotation option. Apply the change and save the updated PDF to view the page in its new orientation.",
              },
              {
                title: "Can I rotate a PDF by 180 degrees?",
                description:
                  "Yes, if the tool supports a 180-degree rotation option. This turns the page upside down and can help correct documents that were scanned or saved in the wrong orientation.",
              },
              {
                title: "Can I rotate a PDF by 270 degrees?",
                description:
                  "A tool that supports 90-degree rotation increments can rotate a PDF by 270 degrees, which is equivalent to rotating it 90 degrees counterclockwise. Check the available rotation options in the tool.",
              },
              {
                title: "Can I rotate just one page of a PDF?",
                description:
                  "Yes, if the PDF rotator supports individual page selection. Select the page you want to correct, choose the rotation angle, and apply the change without intentionally rotating the other pages.",
              },
              {
                title: "Can I rotate all pages of a PDF at once?",
                description:
                  "Yes, if the tool provides an option to rotate the entire document. Select all pages, choose the required angle, and apply the rotation to correct the orientation of the complete PDF.",
              },
              {
                title: "Can I rotate selected pages in a PDF?",
                description:
                  "If page selection is supported, you can choose specific pages and rotate only those pages. This is useful when a document contains a mixture of portrait, landscape, and incorrectly oriented pages.",
              },
              {
                title: "Can I rotate a PDF permanently?",
                description:
                  "A PDF rotator can save the new page orientation in the output document so that the pages remain correctly oriented when reopened. Check the downloaded PDF in another viewer to confirm the changes were saved.",
              },
              {
                title: "Does rotating a PDF change its content?",
                description:
                  "Rotating a PDF changes the page orientation rather than intentionally editing its text or images. However, you should review the output to ensure that all pages display correctly after rotation.",
              },
              {
                title: "Can I rotate a scanned PDF?",
                description:
                  "Yes, scanned PDFs can generally be rotated even when their pages contain images instead of selectable text. This is useful for correcting sideways scans, receipts, forms, and scanned documents.",
              },
              {
                title: "Can I rotate a password-protected PDF?",
                description:
                  "A password-protected PDF may need to be unlocked before its pages can be rotated. You must have the appropriate password and permission to modify the document.",
              },
              {
                title: "Can I rotate a PDF on my phone?",
                description:
                  "You can rotate PDF pages on a compatible iPhone or Android device using a mobile-friendly browser-based tool. Open ShivaPDF.com, select your document, and use the available rotation controls.",
              },
              {
                title: "Can I rotate a PDF on Windows or Mac?",
                description:
                  "A browser-based PDF rotator can work on compatible Windows and Mac computers. Open ShivaPDF.com in a supported browser, choose your PDF, and rotate the pages as needed.",
              },
              {
                title: "Can I rotate a PDF without installing software?",
                description:
                  "A browser-based PDF rotation tool lets you change page orientation without installing a separate desktop application. The available features depend on the tool and your browser.",
              },
              {
                title: "Is ShivaPDF's PDF rotator free?",
                description:
                  "ShivaPDF provides browser-based PDF tools for common document tasks. Check the rotate PDF page for current availability, file-size limits, supported options, and any usage restrictions.",
              },
              {
                title: "Can I rotate a PDF without creating an account?",
                description:
                  "You may be able to rotate PDFs without registration if the tool does not require an account. Check the current ShivaPDF page for access requirements and any applicable limits.",
              },
              {
                title: "Why is my PDF displaying sideways?",
                description:
                  "A PDF may display sideways because the original document was scanned in the wrong orientation or saved with incorrect page rotation settings. Use a PDF rotator to correct the affected pages.",
              },
              {
                title: "Why does my PDF look unchanged after rotating it?",
                description:
                  "The rotation may not have been applied, or the updated document may not have been saved or downloaded. Apply the rotation, save the output file, and reopen it to check the result.",
              },
              {
                title: "Can I rotate a PDF and keep the original file?",
                description:
                  "Yes, if the tool downloads the rotated document as a separate file, you can keep the original PDF unchanged. This allows you to compare both versions or restore the original page orientation later.",
              },
              {
                title: "Can rotating a PDF reduce its file size?",
                description:
                  "Rotating PDF pages does not normally reduce the file size significantly. If you need a smaller document, use a PDF compression tool designed to reduce the file's storage size.",
              },
              {
                title: "Is it safe to rotate confidential PDF documents online?",
                description:
                  "For confidential documents, choose a tool with a clear privacy policy and verified local processing if you want files to remain on your device. Avoid submitting sensitive files to services unless you understand how they are handled.",
              },
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${6504000491}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default RotatePDFMain;
